import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/link_arrow.svg'


const _hoisted_1 = { class: "flex w-full h-md-image m-auto" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "w-full my-md" }
const _hoisted_4 = { class: "text-3xl font-normal" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl w-full mt-auto text-black underline font-bold transition-colors duration-300 group-hover:text-primary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-md" }, "Weiterlesen"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "inline opacity-0 transition-opacity duration-300 group-hover:opacity-100",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "h-full group",
    to: _ctx.post.link.replace(/^https:\/\/wpdev.netconnect.ch/, '')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, {
        class: _normalizeClass(["relative flex flex-col p-lg h-full preview", {
        'preview-fade-left': _ctx.fadingBack,
        'preview-fade-right': _ctx.fadingFront
      }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "m-auto",
              src: _ctx.post.featured_media_src_url
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.formattedDate), 1),
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.post.title.rendered), 1),
          _createElementVNode("div", {
            class: "my-auto",
            innerHTML: _ctx.post.excerpt.rendered
          }, null, 8, _hoisted_5),
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["to"]))
}